export default function Dashboard() {

    return (
        <div>
            <div className="mb-4">
                <h3>Dashboard</h3>
                <p className="text-muted">
                    Welcome to Potech Invoice Management System
                </p>
            </div>

            <div className="row g-4">

                <div className="col-md-3">
                    <div className="card shadow-sm border-0">
                        <div className="card-body">
                            <h6 className="text-muted">Total Clients</h6>
                            <h2>0</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card shadow-sm border-0">
                        <div className="card-body">
                            <h6 className="text-muted">Total Invoices</h6>
                            <h2>0</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card shadow-sm border-0">
                        <div className="card-body">
                            <h6 className="text-muted">Paid</h6>
                            <h2>₹0</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card shadow-sm border-0">
                        <div className="card-body">
                            <h6 className="text-muted">Pending</h6>
                            <h2>₹0</h2>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}